import { createApi } from "@mattfinkel/common-web";
import { auth } from "../firebase";

/**
 * This app's API client.
 *
 * `createApi` carries the content-type guard that makes a 2xx from anything
 * other than the backend a 502 rather than a success: a 200 with an HTML body
 * means Hosting's SPA catch-all, a service worker, or a CDN answered instead
 * of Cloud Run, and without the guard `AuthProvider` reads that as proof of
 * authorization and shows every signed-in Google account the protected UI.
 *
 * Re-export the members so call sites import from this path rather than from
 * the package, which keeps the swap to a different client a one-file change.
 */
export const api = createApi({
  auth,
  baseUrl: import.meta.env.VITE_API_BASE_URL,
});

export const { warmApi, authedFetch, authedFetchRaw, postJson, putJson } = api;
